import { useState } from 'react';
import { createPrimer, deletePrimer, updatePrimer } from '../../../actions/primers';


const usePrimers = (sampleMapId, primers, setPrimers, colorMapActions, sampleActions) => {
  const hookGetPrimers = () => {
    return primers;
  };

  const hookAddLabPrimer = async (data) => {
    let out = [];
    for (const item of data) {
      const newPrimer = await (await createPrimer({
        name: item.name,
        sampleMap: sampleMapId,
        number: item.labPrimerId
      })).json();
      colorMapActions.addPrimer(newPrimer._id);
      out.push(newPrimer);
    }
    setPrimers(primers => [...primers, ...out])
  };

  const hookCreatePrimer = async (order) => {
    const newPrimer = await (await createPrimer({
      name: '',
      volume: 0,
      sampleMap: sampleMapId,
      order,
      customDeclare: true,
    })).json();
    colorMapActions.addPrimer(newPrimer._id);
    setPrimers((primers) => [...primers, newPrimer]);
  };

  const hookDeletePrimer = async (id) => {
    await deletePrimer(id);
    colorMapActions.removePrimer(id);
    setPrimers((primers) => primers.filter((primer) => primer._id !== id));
  };

  const hookUpdateName = async (id, name) => {
    await updatePrimer(id, {
      name,
    });
    setPrimers((primers) =>
      primers.map((primer) => {
        if (primer._id === id) {
          return {
            ...primer,
            name,
          };
        } else {
          return primer;
        }
      })
    );
  };

  const hookUpdateVolume = async (id, volume) => {
    await updatePrimer(id, {
      volume,
    });
    setPrimers((primers) =>
      primers.map((primer) => {
        if (primer._id === id) {
          return {
            ...primer,
            volume,
          };
        } else {
          return primer;
        }
      })
    );
  };

  return {
    getPrimers: hookGetPrimers,
    addLabPrimer: hookAddLabPrimer,
    createPrimer: hookCreatePrimer,
    deletePrimer: hookDeletePrimer,
    updateName: hookUpdateName,
    updateVolume: hookUpdateVolume,
  };
};

export default usePrimers;
